import { defineComponent as _defineComponent } from 'vue'
import useRoomInfo from './useRoomInfoHooks';
import SvgIcon from '../../common/base/SvgIcon.vue';
import Arrow from '../../common/icons/ArrowUpIcon.vue';
import copyIcon from '../../common/icons/CopyIcon.vue';
import '../../../directives/vClickOutside';
import RoomTime from '../../common/RoomTime.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomInfoPC',
  setup(__props) {

const {
  t,
  arrowDirection,
  isShowRoomInfoTitle,
  conferenceTitle,
  isShowRoomInfo,
  roomInfoTabList,
  toggleShowRoomInfoStatus,
  handleClickOutsideRoomInfoContainer,
  onCopy,
} = useRoomInfo();

return { __sfc: true,t, arrowDirection, isShowRoomInfoTitle, conferenceTitle, isShowRoomInfo, roomInfoTabList, toggleShowRoomInfoStatus, handleClickOutsideRoomInfoContainer, onCopy, SvgIcon, Arrow, copyIcon, RoomTime }
}

})